import React from 'react';
import { StarOutlined } from '@ant-design/icons';
import styles from './PremiumUpgradeCard.module.css';

type PremiumUpgradeCardProps = {
  title?: string;
  description?: string;
  buttonText?: string;
  onButtonClick: () => void;
};

/**
 * A premium upgrade card component with gradient background, icon, title, description, and action button
 * @param props - The component props
 * @returns JSX element representing the premium upgrade card
 */
const PremiumUpgradeCard: React.FC<PremiumUpgradeCardProps> = ({
  title,
  description,
  buttonText,
  onButtonClick,
}) => {
  

  return (
    <div className={styles.card}>
      <div className={styles.iconContainer}>
        <StarOutlined className={styles.icon} />
      </div>
      
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
        <button 
          className={styles.button}
          onClick={onButtonClick}
          type="button"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default PremiumUpgradeCard;
